module.exports = __webpack_public_path__ + "img/CrediCore2.3ca734a7.jpg";